<button (click)="openSidenav.emit()" class="button" fxHide.gt-sm mat-icon-button>
  <mat-icon>menu</mat-icon>
</button>
